var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tag,
    {
      tag: "component",
      staticClass: "btn",
      class: ["btn--" + _vm.level].concat(
        _vm.variants.map(function (variant) {
          return "btn--" + variant
        }),
        [{ "btn--icon": _vm.icon }],
        [{ "btn--arrow": _vm.arrow }],
        [{ "btn--no-text": !_vm.text }],
        [{ "btn--reverse": _vm.reverse }]
      ),
      attrs: {
        href: _vm.url || _vm.href,
        type: !_vm.url && _vm.type,
        target: _vm.url || _vm.href ? _vm.target : null,
        disabled: _vm.disabled,
      },
      on: { click: _vm.onClick },
    },
    [
      _vm.icon
        ? _c(_vm.iconComponent(_vm.icon), {
            tag: "component",
            staticClass: "btn__icon",
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.text
        ? _c("span", {
            staticClass: "btn__text",
            domProps: { innerHTML: _vm._s(_vm.text) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.arrow
        ? _c(_vm.arrowComponent, {
            tag: "component",
            staticClass: "btn__arrow",
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }